// RoutedHtmlContent is a React component that renders HTML content and intercepts clicks on internal anchor links to
// navigate using React Router's history, enabling client-side routing for internal links while allowing external and
// special links to behave normally.
import { useHistory } from 'react-router-dom';

interface Props {
    html: string;
    className?: string;
}
export const RoutedHtmlContent = ({ html, className }: Props) => {
    const history = useHistory();

    const handleClick = (e) => {
        const anchor = e.target.closest('a');
        if (!anchor) return;

        const href = anchor.getAttribute('href');
        if (!href) return;

        // ignore external or special links
        if (href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('#')) {
            return;
        }

        e.preventDefault();
        history.push(href);
    };

    return <div className={`${className ?? ''}`} onClick={handleClick} dangerouslySetInnerHTML={{ __html: html }} />;
};
